import axios from 'src/shared/utils/axios';
import { serializeQuerystring } from 'src/shared/utils/object';
import { type DataChangeResuestsFilters } from 'src/modules/DataReview/types';
import {
  type EmployeeRequestedDataChange,
  type ChangeFieldRequest,
  type PaginatedResponseWithTotalCompanyPendingRequests
} from 'src/old/api/dataChangeRequests/types';

const dataChangeRequestsEndpoint = `${process.env.REACT_APP_API_URL}employees/data/change`;
const dataChangeRequestEndpoint = `${process.env.REACT_APP_API_URL}employee/data/change/review`;

export const getDataChangeResuestsEndpointQuery = (filters?: DataChangeResuestsFilters): string => {
  if (!filters) {
    return '';
  }

  let filterString = serializeQuerystring({
    searchTerm: filters.searchTerm || '',
    status: filters.status || ''
  });

  if (filters.currentFilters) filterString += filters.currentFilters;
  return `?offset=${filters?.offset || 0}&limit=${filters?.rowsPerPage || 15}${filterString}`;
};

const getDataChangeResuests = async (
  filters?: DataChangeResuestsFilters
): Promise<PaginatedResponseWithTotalCompanyPendingRequests<EmployeeRequestedDataChange>> => {
  const params = getDataChangeResuestsEndpointQuery(filters);
  const res = await axios.get(`${dataChangeRequestsEndpoint}${params}`);

  return res.data;
};

const putDataChangeRequest = async (personalId: string, updatedDataRequest: ChangeFieldRequest[]): Promise<boolean> => {
  const payload = updatedDataRequest;
  await axios.put(`${dataChangeRequestEndpoint}/${personalId}`, payload);

  return true;
};

export const dataChangeResuestsApi = {
  getDataChangeResuests,
  putDataChangeRequest
};
